import jwImageUrl from './jwImageUrl.js';

const PROFILES = {
  small: 's100',
};

export default function jwIconUrl (template, size = 'small') {
  return jwImageUrl(template, PROFILES[size] || PROFILES.small);
}
